export const WINBACK_LIST_TEXT_KEYS = [
  "winbackListText1",
  "winbackListText2",
  "winbackListText3",
  "winbackListText4",
  "winbackListText5",
  "winbackListText6",
];
